import {
    PostCheckoutMandatoryCustomQuestionsVariant,
    PostCheckoutMandatoryQuestionsInAppVariant,
} from '../../constants/statsig';
import { getPostCheckoutMandatoryCustomQuestionsInWeb } from './getPostCheckoutMandatoryCustomQuestionsInWeb';
import { getPostCheckoutMandatoryQuestionsInApp } from './getPostCheckoutMandatoryQuestionsInApp';

export const getShowMandatoryCustomQuestionsAfterPayment = () =>
    getPostCheckoutMandatoryCustomQuestionsInWeb() ===
        PostCheckoutMandatoryCustomQuestionsVariant.customQuestions ||
    getPostCheckoutMandatoryQuestionsInApp() ===
        PostCheckoutMandatoryQuestionsInAppVariant.customQuestionsInApp;
